<ng-template [ngIf]="config">
  <ng-template [ngIf]="config.type">

<div class="form-group">
    <ng-template [ngIf]="config.type !== 'textarea'">
     
        <ion-label class="form-label">
          {{config.label | multiLang}}
          <ng-template [ngIf]="config.required">
            <ion-text color="danger">*</ion-text>
          </ng-template>
        </ion-label>
        <ion-input [formControlName]="config.name" [placeholder]="placeholder"
          [type]="config.type ? config.type : 'string' " [name]="config.name"
          [required]="config.required ?  config.required : false" [email]="config.type === 'email' ? true : false "
          [pattern]="pattern" class="form-control"></ion-input>
     

    </ng-template>

    <ng-template [ngIf]="config.type === 'textarea'">
     
        <ion-label class="form-label">
          {{config.label | multiLang}}
          <ng-template [ngIf]="config.required">
            <ion-text color="danger">*</ion-text>
          </ng-template>
        </ion-label>
        <ion-textarea [formControlName]="config.name" [placeholder]="placeholder"
          [name]="config.name" [required]="config.required ?  config.required : false" class="form-control"
          autoGrow="true"></ion-textarea>

     
</ng-template>

    <div *ngIf="control.invalid && (control.dirty || control.touched)" class="m-b-10">
      <ion-text *ngIf="control.hasError('required')" color="danger" class="m-b-5">
        <span class="f-12">{{config.name}} is required</span>
      </ion-text>
      <ion-text *ngIf="control.errors.pattern && config.type === 'email'" color="danger" class="m-b-5">
        <span class="f-12">Please enter a valid email address</span>
      </ion-text>
      <ion-text *ngIf="control.errors.pattern && config.type === 'url'" color="danger" class="m-b-5">
        <span class="f-12">Please enter a valid url</span>
      </ion-text>
    </div>



  </div>
  </ng-template>
</ng-template>